window.addEventListener('scroll', () => {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            //console.log(entry.boundingClientRect.top)
            var entry_top = entry.boundingClientRect.top;
            if (entry_top < 350) {
                $('.feature-row__text_as').addClass('text_as_visible');
                $('.image-details-second').show();
            } else {
                $('.feature-row__text_as').removeClass('text_as_visible');
            }
            if (entry_top < -600) {
                console.log("ENTRA AQUI")
                $('.feature-row__text_bs').addClass('text_bs_visible');
                $('.image-details-second').addClass('text_bs_visible');
                $('.feature-row__text_as').addClass('text_as_hidden');
            } else {
                $('.feature-row__text_bs').removeClass('text_bs_visible');
                $('.image-details-second').removeClass('text_bs_visible');
                $('.feature-row__text_as').removeClass('text_as_hidden');
            }

            if (entry_top < -1400) {
                $('.feature-row__text_cs').addClass('text_cs_visible');
                $('.image-details-second').addClass('text_cs_visible');
                $('.feature-row__text_bs').addClass('text_bs_hidden');
            } else {
                $('.feature-row__text_cs').removeClass('text_cs_visible');
                $('.image-details-second').removeClass('text_cs_visible');
                $('.feature-row__text_bs').removeClass('text_bs_hidden');
            }

            if (entry_top < -1650) {
                $('.feature-row__text_ds').addClass('text_ds_visible');
                $('.feature-row__text_cs').addClass('text_cs_hidden');
            } else {
                $('.feature-row__text_ds').removeClass('text_ds_visible');
                $('.image-details-second').removeClass('text_ds_visible');
                $('.feature-row__text_cs').removeClass('text_cs_hidden');
            }

        });
    });

    // Track all sections that have an `id` applied
    document.querySelectorAll('section[id]').forEach((section) => {
        observer.observe(section);
    });

});

!(function (e) {
    function o(e, o) {
        l++, (d = l / c), TweenLite.to(u, 0.7, { progress: d, ease: Linear.easeNone });
    }
    function t() {
        (d = Math.round(100 * u.progress())), e(".txt-perc").text(d + "%");
    }

    var s = new ScrollMagic.Controller(),
        n = ["#slide02", "#slide03 header"],
        l = 0,
        c = e(".bcg").length,
        d = 0;
    e(".bcg")
        .imagesLoaded({ background: !0 })
        .progress(function (e, t) {
            o();
        });
    var u = new TimelineMax({ paused: !0, onUpdate: t });
    if ((u.to(e(".progress span"), 1, { width: 100, ease: Linear.easeNone }), !Modernizr.touch)) {


        n.forEach(function (e, o) {
            {
                //                     var positions = document.getElementById("slide02").getBoundingClientRect();
                //                     var top_po = positions.bottom + window.scrollY;
                //               console.log('checked', top_po);                  
                //                     var t = o + 1;
                //                     new ScrollMagic.Scene({ triggerElement: e, offset: top_po - 2950 }).setClassToggle("#slide0" + t, "is-active").addTo(s);
                //                     new ScrollMagic.Scene({ triggerElement: e, offset: 5100 }).setClassToggle("#slide0" + t, "is-activebs").addTo(s);
                //                     new ScrollMagic.Scene({ triggerElement: e, offset: 5500 }).setClassToggle("#slide0" + t, "is-activecstemp").addTo(s);
                //                     new ScrollMagic.Scene({ triggerElement: e, offset: 5700 }).setClassToggle("#slide0" + t, "is-activecs").addTo(s);
                //                     new ScrollMagic.Scene({ triggerElement: e, offset: 6700 }).setClassToggle("#slide0" + t, "is-activeds").addTo(s);
            }
        });
        {
            new ScrollMagic.Scene({ triggerElement: "#slide02", triggerHook: 0, duration: "200%" }).setPin("#slide02").addTo(s);
        }
        s.scrollTo(function (e) {
            TweenMax.to(window, 1, { scrollTo: { y: e }, ease: Power1.easeInOut });
        }),
            e(document).on("click", "a[href^='#']", function (o) {
                var t = e(this).attr("href");
                e(t).length > 0 && (o.preventDefault(), s.scrollTo(t), window.history && window.history.pushState && history.pushState("", document.title, t));
            });
    }
})(jQuery);